enum OVERLAYS {
  WEBCAM_SHARE = 'webcam-share',
  TOOLTIP_GUIDE = 'tooltip-guide',
  CHAT = 'chat',
  PARTICIPANTS = 'participants',
  TRAINER_TOOLS = 'trainer-tools',
  ADMIN_TOOLS = 'admin-tools',
  TOOLBOX = 'toolbox',
  TOOL_ACTIONS = 'tool-actions',
  ACTIONS = 'actions',
  EVENT_SCHEDULER = 'event-scheduler',
  PROFILE = 'profile',
}

export default OVERLAYS;
